import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import Playback               from '../../../../State/Stores/Playback/Playback';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';
import FastForward            from '../FastForward';
import PlayPause              from '../PlayPause';
import Rewind                 from '../Rewind';

import * as styles from './playbackButtons.css';

interface IPlaybackButtonsProps extends IConnectProps<Playback> {
    areControlsIdle: boolean;
    isSettingsOpen: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.PLAYBACK)
class PlaybackButtons extends React.Component<IPlaybackButtonsProps> {
    public shouldComponentUpdate(nextProps: IPlaybackButtonsProps): boolean {
        return (
            nextProps.value.playbackStatus !== this.props.value.playbackStatus ||
            nextProps.areControlsIdle !== this.props.areControlsIdle ||
            nextProps.isSettingsOpen !== this.props.isSettingsOpen
        );
    }

    public render(): JSX.Element {
        const {uiEvents$, value, areControlsIdle, isSettingsOpen} = this.props;
        const {isLoading, isUnloaded, hasErrored, media} = value;

        if (isLoading || isUnloaded || hasErrored || media.isLinear || isSettingsOpen) return null;

        const className = composeTokenList([
            styles.playbackButtons,
            [this.props.areControlsIdle, styles.playbackButtonsIdle]
        ]);

        const testId = composeTokenList([
            TestIds.PLAYER_PLAYBACK_BUTTONS,
            [!this.props.areControlsIdle, TestIds.PLAYER_PLAYBACK_BUTTONS_VISIBLE]
        ]);

        return (
            <div
                className={className}
                data-test-id={renderTestId(testId)}>
                <Rewind uiEvents$={uiEvents$} areControlsIdle={areControlsIdle}/>
                <PlayPause uiEvents$={uiEvents$} areControlsIdle={areControlsIdle}/>
                <FastForward uiEvents$={uiEvents$} areControlsIdle={areControlsIdle}/>
            </div>
        );
    }
}

export default PlaybackButtons;